const getPopupContainer = (triggerNode: HTMLElement) => {
  return (triggerNode?.parentNode as HTMLElement) || document.body;
};

export default getPopupContainer;
